import { render, staticRenderFns } from "./pgRequest.vue?vue&type=template&id=1249aa55"
import script from "./pgRequest.vue?vue&type=script&lang=js"
export * from "./pgRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports